<!--  -->
<template>
  <div class="tewbox">
    <div style="margin-bottom:10px" class="search_box">
      <el-input v-model="query.account_name" style="width:200px" placeholder="请输入公众号名称" />
      <el-select v-model="query.onlyMe" placeholder="请选择">
        <el-option
          v-for="item in accountarr"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        />
      </el-select>
      <el-button type="primary" @click="search">搜索</el-button>
      <el-button type="primary" @click="reast">重置</el-button>
    </div>
    <el-table
      :data="tableData"
      border
      style="width: 100%"
    >
      <el-table-column
        prop="account_name"
        label="公众号名称"
        width="180"
        align="center"
      />
      <el-table-column
        prop="app_id"
        label="公众号appid"
        width="180"
        align="center"
      />
      <el-table-column
        prop="address"
        label="操作"
        align="center"
      >
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="choose(scope.row)">选择</el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination-right
      :total="total"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
  </div>
</template>

<script>
import { officialAccountlist } from '@/api/sourceMaterial.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
export default {
  components: {
    PaginationRight
  },
  data() {
    return {
      query: {
        page: 1,
        pageSize: 10,
        account_type: 1,
        account_name: null,
        is_main: null,
        onlyMe: 2
      },
      accountarr: [{
        value: 1,
        label: '查看组内公众号'
      }, {
        value: 2,
        label: '我关联的公众号'
      }],
      tableData: [],
      total: null
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    sendrs(id) {
      this.query.is_main = id
      this.temlist()
    },
    search() {
      this.query.page = 1
      this.temlist()
    },
    reast() {
      this.query.page = 1
      this.query.account_name = null
      this.temlist()
    },
    async temlist() {
      const data = await officialAccountlist(this.query)
      this.tableData = data.data.list
      this.total = data.data.total
      console.log('data', data)
    },
    // 分页
    fetchPageSize(e) {
      this.query.pageSize = e
      this.temlist()
    },
    fetchCurrentPage(e) {
      this.query.page = e
      this.temlist()
    },
    choose(item) {
      this.$emit('callback', item)
      console.log('item', item)
    }

  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.tewbox{
  padding: 10px;
}
</style>
